<mat-form-field
  [floatLabel]="floatLabel"
  [appearance]="appearance"
  [formGroup]="formGroup"
  [ngClass]="getNgClasses()"
  [ngStyle]="getNgStyle()"
  *ngIf="isVisible">
  <mat-label *ngIf="label">{{label | translate}}</mat-label>
  <input matInput #input
         [id]="id"
         [name]="name"
         [type]="type"
         [placeholder]="placeholder | translate"
         [formControl]="control"
         autocomplete="off"
         [imask]="mask"
         [readonly]="isReadonly"
         [unmask]="unmask"
         (paste)="phoneNumberPasteFilter()"
         (keypress)="phoneNumberFilter($event, input.value)"
         [style.text-align]="textAlign"
         [attr.maxlength]="maxLength > 0 ? maxLength : null"/>
  <mat-icon *ngIf="tooltip" matSuffix [matTooltip]="tooltip | translate" matTooltipPosition="right">
    info_outline
  </mat-icon>
  <mat-hint *ngIf="hint" align="start">{{hint | translate}}</mat-hint>
  <mat-hint *ngIf="maxLength" align="end">{{input.value?.length || 0}}/{{maxLength}}</mat-hint>
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
